<div mat-dialog-title class="dialog-header">
    <h5>Hub History</h5>
    <nb-icon mat-dialog-close icon="close-outline"></nb-icon>
</div>
<mat-dialog-content>
    <mat-tab-group>
        <mat-tab label="Transfer">
            <div class="loader" *ngIf="loading">
                <div>
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
            </div>
            <div *ngIf="dataSourceForTransfer.length">
                <table mat-table [dataSource]="dataSourceForTransfer" class="mat-elevation-z8">
                    <ng-container matColumnDef="fromUser">
                      <th mat-header-cell *matHeaderCellDef> From User </th>
                      <td mat-cell *matCellDef="let element"> {{element.fromUser?element.fromUser:'NA'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="toUser">
                      <th mat-header-cell *matHeaderCellDef> To User </th>
                      <td mat-cell *matCellDef="let element"> {{element.toUser?element.toUser:'NA'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="fromHubId">
                        <th mat-header-cell *matHeaderCellDef> HubId </th>
                        <td mat-cell *matCellDef="let element">{{element.fromHubId?element.fromHubId:'NA'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="invokerEmailId">
                        <th mat-header-cell *matHeaderCellDef> Invoker Email </th>
                        <td mat-cell *matCellDef="let element">{{element.invokerEmailId?element.invokerEmailId:'NA'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="invokedTime">
                        <th mat-header-cell *matHeaderCellDef> Invoked Time </th>
                        <td mat-cell *matCellDef="let element">{{element.invokedTime | date:'medium'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="removeAcls">
                        <th mat-header-cell *matHeaderCellDef> Access Removed </th>
                        <td mat-cell *matCellDef="let element">{{element.removeAcls == undefined ? '' : element.removeAcls.toString().toUpperCase()}}</td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element">{{element.status?element.status:'NA'}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForTransfer"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForTransfer;"></tr>
                </table>
            </div>
            <div *ngIf="loading==false && !dataSourceForTransfer.length" class="nothing">
                <div><p>There was no Transfer record found for this HUB ID.</p></div>
            </div>
        </mat-tab>
        <mat-tab label="Replacement">
            <div class="loader" *ngIf="loading">
                <div>
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
            </div>
            <div *ngIf="dataSourceForReplacement.length">
                <table mat-table [dataSource]="dataSourceForReplacement" class="mat-elevation-z8">
                    <ng-container matColumnDef="toUser">
                      <th mat-header-cell *matHeaderCellDef> User </th>
                      <td mat-cell *matCellDef="let element"> {{element.toUser?element.toUser:'NA'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="fromHubId">
                      <th mat-header-cell *matHeaderCellDef> From HubId </th>
                      <td mat-cell *matCellDef="let element"> {{element.fromHubId?element.fromHubId:'NA'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="toHubId">
                        <th mat-header-cell *matHeaderCellDef> To HubId </th>
                        <td mat-cell *matCellDef="let element"> {{element.toHubId?element.toHubId:'NA'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="invokerEmailId">
                        <th mat-header-cell *matHeaderCellDef> Invoker Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.invokerEmailId?element.invokerEmailId:'NA'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="invokedTime">
                        <th mat-header-cell *matHeaderCellDef> Invoked Time </th>
                        <td mat-cell *matCellDef="let element"> {{element.invokedTime |  date:'medium'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.status?element.status:'NA'}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForReplaceMent"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForReplaceMent"></tr>
                </table>
            </div>
            <div *ngIf="loading==false && !dataSourceForReplacement.length" class="nothing">
                <div><p>There was no Replacement record found for this HUB ID.</p></div>
            </div>
        </mat-tab>
        <mat-tab label="Commission/Decommission">
            <div class="loader" *ngIf="loading">
                <div>
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
            </div>
            <div *ngIf="dataSourceForComDcom.length">
                <table mat-table [dataSource]="dataSourceForComDcom" class="mat-elevation-z8">
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef> Type </th>
                      <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                      <th mat-header-cell *matHeaderCellDef> Date </th>
                      <td mat-cell *matCellDef="let element"> {{element.date!=="NA"? (element.date | date:'medium'):element.date}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForComDcom"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForComDcom"></tr>
                </table>
            </div>
            <div *ngIf="loading==false && !dataSourceForComDcom.length" class="nothing">
                <div><p>There was no Commission/Decommission record found for this HUB ID.</p></div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>